import React, {useRef, useState} from 'react';
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";
import {sendPresRequestFile_api} from "../../../Services/apis";
import toaster from "toasted-notes";
import {Modal, Spin} from "antd";


function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function SingleBannerSec({item,link}){

    const [currentItem,set_currentItem] = useState(null);

//--------------------------------------------------------------------- Start Prescription ----------------------------------------------------------

    const goTo = async(it)=>{
        if(it.items.length>0){
            if(it.items[0].link_to==="mall_parking"){
                showModal(it.items[0])
            }else{
                return link(it.items[0].link_to, it.items[0])
            }
        }else{
            return link(it.items[0].link_to, it.items[0])
        }
    }


    const inputFileRef = useRef( null );
    const showModal = (i) => {
        set_currentItem(i)
        set_visible(true);
    };

    const handleOk = () => {
        set_visible(false);
    };

    const handleCancel = (e) => {
        e.stopPropagation();
        set_visible(false);
    };

    const [loading,set_loading] = useState(false);
    const [visible,set_visible] = useState(false);
    const [file,set_file] = useState({});

    const onFileChange = ( e ) => {
        console.log( e.target.files );
        if(e.target.files.length > 0){
            set_file(e.target.files[0])
        }
    }
    const onBtnClick = () => {
        inputFileRef.current.click();
    }

    const [national_code,set_national_code] = useState("")
    const [prescription_id,set_prescription_id] = useState("")
    const [description,set_description] = useState("")


    const sendPresRequest = async ()=>{
        const formData = new FormData();
        formData.append('file_1', file);
        formData.append('national_code', national_code);
        formData.append('prescription_id', prescription_id);
        formData.append('description', description);
        set_loading(true);
        let merchantId = currentItem.link_to_uid.split("/")[0]
        let product = {uid:currentItem.link_to_uid.split("/")[1]}
        try{
            const res = await sendPresRequestFile_api(formData,merchantId)
            set_loading(false);
            toaster.notify(({ onClose }) => (<Success   message={"درخواست شما با موفقیت ارسال شد"}/>),{duration: 2000});
            set_visible(false);
        }catch(e){
            set_loading(false);
            console.error(e);
            toaster.notify(({ onClose }) => (<Error   message={"مشکل در ارسال اطلاعات"}/>),{duration: 2000});
        }
    }


    //--------------------------------------------------------------------- End Prescription ----------------------------------------------------------



    return(
        <div key={item.items[0].uid} className={`single-bar ${item.has_shadow?"shadow-sec":""}`} onClick={e=>goTo(item)}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <>
                {/*<img  src={item.items[0].image} alt=""/>*/}
                <LazyImage type={'banner'} src={item.items[0].image}/>
                <span className="block-title">{item.items[0].title}</span>
            </>
            <Modal visible={visible} footer={null} onOk={handleOk} onCancel={handleCancel}   closable={false} bodyStyle={{padding:0}}>
                <div className="booking-header">
                    <span>ثبت نسخه</span>
                </div>

                <Spin spinning={loading}>
                    <div className="booking-form">
                        <br/>
                        <div className="booking-form-item">
                            <input
                                value={national_code}
                                onChange={e=>set_national_code(e.target.value)}
                                type="text" name="" id="" placeholder="کد ملی"/>
                        </div>

                        <div className="booking-form-item">
                            <input
                                value={prescription_id}
                                onChange={e=>set_prescription_id(e.target.value)}
                                type="text" name="" id="" placeholder="کد رهگیری"/>
                        </div>

                        {/*<div className="booking-form-item">*/}
                        {/*    <select name="" id="">*/}
                        {/*        <option value="">بیمه تامین اجتماعی</option>*/}
                        {/*        <option value="">بیمه خدمات درمانی</option>*/}
                        {/*        <option value="">بیمه آزاد</option>*/}
                        {/*    </select>*/}
                        {/*</div>*/}
                        <div className="booking-form-item">
                    <textarea
                        placeholder="توضیحات"
                        value={description}
                        onChange={e=>set_description(e.target.value)}
                        name="" id="" cols="30" rows="3">
                    </textarea>
                        </div>

                        <div className="booking-form-item">
                            <span className="booking-upload-btn" onClick={onBtnClick}>{file && file.name?file.name:" آپلود تصویر نسخه "}</span>
                        </div>

                    </div>


                    <br/>
                    <div className="booking-foot">
                        <span className="booking-submit-btn" onClick={sendPresRequest}>ثبت نسخه</span>
                        <input
                            ref={inputFileRef}
                            onChange={onFileChange}
                            type="file" name="" id="" placeholder="تصویر نسخه"/>
                    </div>
                </Spin>
            </Modal>
        </div>
            )
}

export default SingleBannerSec
